export const ShortenNumber = (num) => {
    const formattedPrice = Math.floor(num / 100);
    return formattedPrice >= 1000000 ? 
        `${(formattedPrice / 1000000).toFixed(1)} млн.` : 
        formattedPrice.toLocaleString('ru-RU') + ' ';
};